// extracted by mini-css-extract-plugin
export default {"video":"dnnwU","iframe":"hPXGk"};